import { profileConstants } from '../constants';

const initialPointsState = {
    loading: false,
    mypoints: null,
    error: null,
    showAwardModal: false,
    awardMessage: ''
};

const pointsReducer = (state = initialPointsState, action) => {
    switch (action.type) {
        case profileConstants.FETCH_MYPOINTS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case profileConstants.FETCH_MYPOINTS_SUCCESS:
            return {
                ...state,
                loading: false,
                mypoints: action.points,
                error: null
            };
        case profileConstants.FETCH_MYPOINTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case profileConstants.UPDATE_MYPOINTS_FROM_SOCKET:
            return {
                ...state,
                mypoints: {
                    ...(state.mypoints || {}),
                    TotalScore: action.points.TotalScore,
                    AwardCoins: action.points.AwardCoins,
                    IsAwarded: action.points.IsAwarded,
                    AwardFlagMessages: action.points.AwardFlagMessages
                },
                showAwardModal: action.points.IsAwarded === 'Y',
                awardMessage: action.points.AwardFlagMessages
            };
        case profileConstants.RESET_AWARD_FLAGS:
            return {
                ...state,
                mypoints: state.mypoints
                    ? {
                        ...state.mypoints,
                        IsAwarded: '',
                        AwardFlagMessages: ''
                    }
                    : state.mypoints
            };
        case profileConstants.SHOW_AWARD_POPUP:
            return {
                ...state,
                showAwardModal: true,
                awardMessage: action.message
            };
        case profileConstants.HIDE_AWARD_POPUP:
            return {
                ...state,
                showAwardModal: false,
                awardMessage: ''
            };

        default:
            return state;
    }
};

export default pointsReducer;
